export interface BorderlineCandidateDto {
  candidateId: string;
  candidateSerialNumber: string;
  candidateFirstName: string;
  candidateLastName: string;
  examId: string;
  examNumber: string;
  examDate: string;
  examCenterId: string;
  examCenterName: string;
  syllabusName: string;
  moduleName: string;
}

class BorderlineCandidateCollection {
  candidates: BorderlineCandidateDto[];

  constructor(candidates: BorderlineCandidateDto[]) {
    this.candidates = candidates;
  }

  length(): number {
    return this.candidates.length;
  }
}

export default BorderlineCandidateCollection;

